import React from 'react';
import ZoomSpinner from 'utils/assets/images/Zoom-Spinner.svg';
import { Box } from '@mui/material';

const LoadingSpinner = () => {
  return (
    <Box
      sx={{
        animation: 'spin 3s linear infinite',
        '@keyframes spin': {
          '0%': {
            transform: 'rotate(360deg)',
          },
          '100%': {
            transform: 'rotate(0deg)',
          },
        },
      }}
    >
      <img src={ZoomSpinner} width='50px' />
    </Box>
  );
};

export default LoadingSpinner;
